import {Component, OnInit} from '@angular/core';
import {AppAvailableLanguagesService} from "../../app-available-languages.service";
import {Localization} from "../../modules/common/enums/localization";
import {TranslateService} from "@ngx-translate/core";
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss']
})
export class LanguageSwitcherComponent implements OnInit {
  public availableLanguages: string[];
  public readonly Localization = Localization;

  constructor(
      private readonly languages: AppAvailableLanguagesService,
      private readonly translation: TranslateService,
      private readonly self: MatDialogRef<LanguageSwitcherComponent, string>,
  ) {
  }

  async ngOnInit(): Promise<void> {
    const allLanguages = await this.languages.getLanguages().toPromise();
    this.availableLanguages = allLanguages.filter(language => language !== this.translation.currentLang)
  }

  public activate(language: string) {
    this.translation.use(language);
    this.self.close(language);
  }
}
